import React from "react";
import CommunityNavigationStore from "../../navigation/communityNavigationStore";
import HowSetupsWorkPopUp from "./HowSetupsWorkPopUp";

const SetupsHeader: React.FC = () => {
  const handleHowSetupsWorkClick = () => {
    CommunityNavigationStore.setPopUpView({
      onClose: () => {
        CommunityNavigationStore.setPopUpView(null);
      },
      children: <HowSetupsWorkPopUp />,
    });
  };

  return (
    <>
      <div className="text-left mb-2">
        <h1 className="text-4xl font-nostalgic text-white mb-4">SETUPS</h1>
      </div>

      <div className="flex">
        <button
          type="button"
          className="text-sm font-medium mb-7 cursor-pointer bg-transparent border-none text-white"
          onClick={handleHowSetupsWorkClick}
        >
          ℹ️ How do setups work?
        </button>
      </div>
    </>
  );
};

export default SetupsHeader;
